<template>
    <div class="">
        <logo-component v-if="!embedded"></logo-component>

        <section class="account-form">
            <div class="m-page-container">
                <div class="heading">
                    <h4 class="heading__h4">{{ heading }}</h4>
                    <p>Welcome to Beyond Ulta Beauty Rewards<sup>&#8482;</sup>. You already earn Ulta Beauty Rewards<sup>&trade;</sup> with us—now save at your other favorite retailers, too. You&rsquo;ll start receiving offers from the places you love to shop—just pick the offers you&rsquo;re most excited about and use your enrolled Mastercard to purchase.
                    </p>
                </div>

                <div class="row g-0">
                    <div class="col-12 col-md-6 offset-md-3">
                        <div v-if="errs.length">
                            <b>Please correct the following error(s):</b>
                            <ul>
                                <li  class="alert alert-danger" v-for="error in errs">{{ error }}</li>
                            </ul>
                        </div>
                        <form method="POST" action="/login">
                            <div class="form-container">
                                <div class="form-element">
                                    <label for="email" class="title">E-Mail Address</label>
                                    <input id="email" type="email" class="" v-model="email" required autofocus>
                                </div>

                                <div class="form-element">
                                    <label for="password" class="title">Password</label>
                                    <input id="password" type="password" class="" v-model="password" required>
                                </div>

                                <div class="sign_in_container">
                                    <div class="sign_in_container_item">
                                        <button type="submit" :disabled="loading" class="button pink midsize wide py-3 me-4 wid" @click="handleSubmit">
                                            {{this.loading ? 'Please wait' : submitLabel}}
                                        </button>
                                    </div>
                                    <div v-if="!embedded" class="sign_in_container_item">
                                        <router-link tag="button" class="button pink-border midsize px-5 py-3 wid" to="/forgot_password">Forgot Password?</router-link>
                                    </div>
                                    <div v-if="!embedded" class="new_user_container sign_in_container_item wid">
                                        <a class="px-5 py-3 fs-4 new_user" href="/register">New User?</a>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </section>

        <footer-component v-if="!embedded"></footer-component>
    </div>
</template>

<script>
    import FooterComponent from './FooterComponent.vue'
    import LogoComponent from "./LogoComponent.vue"

    export default {
        components: { LogoComponent, FooterComponent },
        // When `embedded` is true (e.g. inside the campaign modal) the page chrome
        // is hidden and, on success, an `authenticated` event is emitted instead of
        // redirecting so the host can decide what happens next.
        props: {
            embedded: {
                type: Boolean,
                default: false
            },
            heading: {
                type: String,
                default: 'Sign In'
            },
            submitLabel: {
                type: String,
                default: 'Login'
            },
            // Optional prefilled email (e.g. carried over from the register form when
            // the account already exists).
            initialEmail: {
                type: String,
                default: ''
            }
        },
        data(){
            return {
                errs: [],
                email : this.initialEmail,
                password : "",
                loading:false
            }
        },
        methods : {
            resetErr() {
                this.errs = [];
            },
            handleSubmit(e){
                e.preventDefault();
                this.resetErr();
                if (this.password.length > 0) {
                    this.loading = true;
                    axios.post('/login', {
                        email: this.email,
                        password: this.password
                    })
                        .then(response => {
                           if(response.data && response.data.status && response.data.status == 'success') {

                               if (this.embedded) {
                                   this.$emit('authenticated');
                               } else if(this.$route.query.target && this.$route.query.target == 'my_account') {
                                   this.$router.push({ name: 'my_account' });
                               } else {
                                   this.$router.push({ name: 'offers' });
                               }
                           }
                           else {
                               this.errs.push("An error occurred. Please try again.");
                           }
                        })
                        .catch( err => {
                            if(err.response && err.response.data && err.response.data.message) {
                                if(err.response.data.message.includes('CSRF token mismatch')) {
                                    this.errs.push("Please refresh the page and try again.");
                                    location.reload();
                                } else if(err.response.data.message.includes('Too many login attempts')) {
                                    this.errs.push(err.response.data.message);
                                } else if(err.response.data.message.includes('credentials do not match')) {
                                    this.errs.push(err.response.data.message);
                                } else {
                                    this.errs.push("Invalid username or password. Please try again.");
                                }
                            } else {
                                this.errs.push("An error occurred. Please try again.");
                            }
                        }).finally(() => {
                          this.loading = false;
                    });
                }
            }
        },
    }
</script>

<style scoped>

    a.new_user:hover {
    text-decoration: underline;
    color: black
}

    .sign_in_container {
        display: flex;
    }

    .new_user_container {
        display: flex;
        justify-content: center;
        align-items: center
    }
    .sign_in_container_item {
        margin: 0;
    }

    .wid {
        /*width: 100%;*/
    }

    @media screen and (max-width: 600px){

        .sign_in_container {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }

        .sign_in_container_item {
            margin: 1vw;
            width:100%
        }

        .wid {
            width: 100%;
        }
    }

</style>
